export default {
  API: {
    GraphQL: {
      endpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
      region: process.env.VUE_APP_AWS_REGION,
      defaultAuthMode: "userPool",
    },
  },
  Auth: {
    Cognito: {
      userPoolId: process.env.VUE_APP_USER_POOL_ID,
      userPoolClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.VUE_APP_OAUTH_DOMAIN,
          scopes: ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
          redirectSignIn: [process.env.VUE_APP_BASE_URL],
          redirectSignOut: [process.env.VUE_APP_BASE_URL],
          responseType: "code",
        },
      },
    },
  },
};
